var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParty = function SvgParty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M23.2 45.2 8 88l42.8-15.16M16 12h.04M88 32h.04M60 8h.04M88 80h.04M88 8l-8.96 3a11.6 11.6 0 0 0-7.84 12.48c.4 3.44-2.28 6.52-5.8 6.52h-1.52c-3.44 0-6.4 2.4-7.04 5.76L56 40m32 12-3.28-1.32c-3.44-1.36-7.28.8-7.92 4.44-.44 2.8-2.88 4.88-5.72 4.88H68M44 8l1.32 3.28c1.36 3.44-.8 7.28-4.44 7.92-2.8.4-4.88 2.88-4.88 5.72V28m8 24c7.72 7.72 11.32 16.68 8 20s-12.28-.28-20-8-11.32-16.68-8-20 12.28.28 20 8"
  })));
};
export default SvgParty;